import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import Data from '../../../../components/Display/Data';
import '../../../../components/Display/Data.scss';
import MultiLineData from '../../../../components/Display/MultiLineData';
import Section from '../../../../components/Display/Section';
import { getImage } from '../../../../utils/imageHelper';

function NewsDetail({ news, handleUpdateNews, handleDelete }) {
  const updateNewsActions = [
    {
      onClick: handleUpdateNews,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (news) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette Actualité ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(news)
    });
  };

  return (
    <div className={`h-full w-full flex-col flex gap-5`}>
      <Section label="Informations Générales" actions={updateNewsActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={news.title} large translatable />
        </div>

        <div className="flex flex-wrap gap-5">
          <MultiLineData
            key="content"
            label={'Contenu'}
            value={news.content}
            large
            asHtml
            translatable
          />
        </div>
      </Section>
      <Section label="Image principale">
        <img
          className="w-96"
          src={news.image ? news.image.file : getImage('img-ph.png')}
          alt={news.image ? news.image.label : 'Non renseignée'}
        />
      </Section>

      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={"Supprimer l'actualité"}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(news)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default NewsDetail;
